import React from 'react';
import './App.css';
import HomeScreen from './HomeScreen';

function App() {
  return (
    <div className="app">
      <HomeScreen />
    </div>
  );
}

export default App;
